export function resize() {
	// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${ vh }px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${ vw }px`);
	let lastWidth = window.innerWidth;

	let lastHeaderHeight = 0;

	const updateHeaderHeight = () => {
		const headerElement = document.querySelector('.site-header');
		if (headerElement) {
			// Store the original minHeight BEFORE any modifications
			const originalMinHeight = headerElement.style.minHeight;

			// If minHeight is currently set to anything (including '0'), navigation.js
			// has touched the header. Skip measurement to avoid interference.
			if (originalMinHeight && originalMinHeight !== '') {
				return;
			}

			// Check if header has expanded minHeight set by navigation.js hover
			// This indicates a dropdown is open/expanding
			if (headerElement.style.minHeight && headerElement.style.minHeight.includes('calc')) {
				return;
			}

			// Check if dropdown is currently visible/open - if so, skip recalculation
			const dropdown = headerElement.querySelector('.site-header__dropdown');
			if (dropdown) {
				const dropdownStyles = window.getComputedStyle(dropdown);
				const isDropdownVisible = dropdownStyles.display !== 'none' &&
										  dropdownStyles.visibility !== 'hidden' &&
										  dropdownStyles.opacity !== '0';

				if (isDropdownVisible) {
					return;
				}
			}

			// Also check if any navigation items are being hovered
			const hoveredNavItem = headerElement.querySelector('.site-navigation__item:hover');
			if (hoveredNavItem) {
				return;
			}

			// Check if navigation list is being hovered (which triggers the expand)
			const navList = headerElement.querySelector('.site-navigation__primary-list:hover');
			if (navList) {
				return;
			}

			// Temporarily clear minHeight to ensure we measure natural content size
			// (navigation.js sets minHeight when hovering, which could affect wrapper measurements)
			headerElement.style.minHeight = '';

			// ALWAYS hide the dropdown before measuring to ensure it's never included
			const originalDropdownDisplay = dropdown ? dropdown.style.display : null;
			if (dropdown) dropdown.style.display = 'none';

			// Measure only the main header wrapper (exclude secondary nav)
			const mainWrapper = headerElement.querySelector('.site-header__wrapper:not(.site-header__secondary)');
			let measuredHeight = 0;

			if (mainWrapper) {
				measuredHeight = mainWrapper.offsetHeight;
			} else {
				// Fallback: measure header excluding dropdown and secondary nav
				const secondaryNav = headerElement.querySelector('.site-header__secondary');

				if (secondaryNav) {
					const originalSecondaryDisplay = secondaryNav.style.display;
					secondaryNav.style.display = 'none';
					measuredHeight = headerElement.offsetHeight;
					secondaryNav.style.display = originalSecondaryDisplay;
				} else {
					measuredHeight = headerElement.offsetHeight;
				}
			}

			// Restore dropdown and minHeight after all measurements are done
			if (dropdown) dropdown.style.display = originalDropdownDisplay;
			headerElement.style.minHeight = originalMinHeight;

			const isDesktop = window.innerWidth > 980;

			// Determine final height
			let finalHeight = measuredHeight;

			// On desktop, ALWAYS enforce minimum height of 140px - no exceptions
			if (isDesktop) {
				finalHeight = Math.max(measuredHeight, 140);
			}

			// Always update (remove the check to ensure it always sets the value)
			document.documentElement.style.setProperty('--header-height', `${ finalHeight }px`);
			lastHeaderHeight = finalHeight;
		} else {
			// If header element not found, set default
			const defaultHeight = 140;
			document.documentElement.style.setProperty('--header-height', `${ defaultHeight }px`);
			lastHeaderHeight = defaultHeight;
		}
	};

	// Force multiple initial measurements to catch the correct height
	const forceInitialUpdate = () => {
		updateHeaderHeight();
		requestAnimationFrame(() => {
			updateHeaderHeight();
		});
	};

	// Initial header height setup
	forceInitialUpdate();

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth !== window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}

		// Update header height on resize
		updateHeaderHeight();
	};

	// Update on window resize
	window.addEventListener('resize', () => {
		resizeVars();
	});

	// Update on scroll to recalculate when header size changes
	// But skip updates when at the top of the page to avoid interference with nav hover states
	let scrollTimeout;
	window.addEventListener('scroll', () => {
		clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(() => {
			// Only update if we've scrolled away from the top
			// When at the top, the header is in its natural state and shouldn't be recalculated
			// (prevents interference with navigation.js minHeight changes on hover)
			if (window.scrollY > 10) {
				updateHeaderHeight();
			}
		}, 50);
	}, { passive: true });

	// Update header height when mobile navigation is toggled
	const navButton = document.querySelector('.site-navigation__navicon');
	if (navButton) {
		navButton.addEventListener('click', () => {
			// Wait for animation to complete before recalculating
			// Multiple updates to catch different stages of the animation
			setTimeout(() => updateHeaderHeight(), 50);
		});
	}

	// Initial delayed update
	setTimeout(function() {
		resizeVars();
	}, 100);

	// Additional updates to catch header transitions after page load
	// Useful when page reloads at a scrolled position
	const rafUpdates = [0, 50, 100, 200, 300, 400, 600, 800, 1000, 1500];
	rafUpdates.forEach(delay => {
		setTimeout(() => {
			updateHeaderHeight();
		}, delay);
	});

	// Ensure we update once fonts and images are loaded
	if (document.readyState === 'complete') {
		setTimeout(() => updateHeaderHeight(), 0);
	} else {
		window.addEventListener('load', () => {
			updateHeaderHeight();
			// Check again shortly after load
		});
	}
}

